import React, { useState } from "react";
import { cn } from "@/lib/utils";

interface SwapDetailsProps {
    sellAssetInfo: any;
    buyAssetInfo: any;
    slippagePercentage?: number;
    minReceiveValue: string;
}

const SwapDetails: React.FC<SwapDetailsProps> = ({
    sellAssetInfo,
    buyAssetInfo,
    slippagePercentage,
    minReceiveValue,
}) => {
    const [showMoreInfo, setShowMoreInfo] = useState(false);

    // Calculate rate safely
    const rate =
        sellAssetInfo?.price && buyAssetInfo?.price && buyAssetInfo?.price !== 0
            ? (sellAssetInfo.price / buyAssetInfo.price).toFixed(4)
            : "N/A";

    return (
        <div className="flex items-center flex-col gap-2 px-3">
            {slippagePercentage && (
                <div className="flex-1 flex gap-2 justify-between w-full">
                    <span>Slippage</span>
                    <span>{slippagePercentage == 0 ? "Auto" : slippagePercentage + "%"}</span>
                </div>
            )}

            <div className="flex-1 flex gap-2 justify-between w-full">
                <span>Rate</span>
                <span>
                    {rate} {buyAssetInfo?.asset?.symbol ?? ""} = 1 {sellAssetInfo?.asset?.symbol ?? ""}
                </span>
            </div>

            <div className="w-full">
                <button
                    type="button"
                    className={cn("w-full flex justify-between items-center")}
                    onClick={() => setShowMoreInfo(!showMoreInfo)}
                >
                    <span>More</span>
                    <span className={cn("transition-transform", showMoreInfo ? "rotate-180" : "")}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4 6L8 10L12 6"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                </button>

                {showMoreInfo && (
                    <div className="mt-2 bg-card-foreground/5 rounded-lg flex flex-col gap-2 ">
                        <div className="flex-1 flex gap-2 justify-between w-full">
                            <span>Min receive</span> <span>{minReceiveValue}</span>
                        </div>
                        <div className="flex-1 flex gap-2 justify-between w-full">
                            <span>Fee </span> <span>~≤ {0.2} TON</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SwapDetails;
